import React, { Component } from 'react'
import IMG1 from '../images/memoa7.png'
import IMG2 from '../images/spexor7.png'
import IMG3 from '../images/apartly7.png'
import Gradient from '../images/BackgroundGradient.png'
import { Link } from 'react-router-dom'
import { Grid, styled } from '@mui/material'

import PDF from "../documents/Memoa.pdf"
import PDF2 from "../documents/CaseStudy_Preview.pdf"


import Project from '../components/Project'
import Project2 from '../components/Project2'
import Project3 from '../components/Project3'



const portfolio = [
    {
        id: 1,
        company: "User Research and Interface Design",
        title: "memoa",
        image: IMG1,
        url: PDF
    },
    {
        id: 2,
        company: "Bosch spexor",
        title: "Designing a B2B app for Bosch startup spexor",
        image: IMG2,
        url: PDF2
    },
     {
         id: 3,
         company: "Apartly",
    //     title: "Gig economy app: unifi",
         image: IMG3,
         url: "https://www.figma.com/proto/LwCfAyLZaA0P1umhRj4cvL/Apartly-Design-Systems?page-id=7%3A1650&node-id=7-1651&node-type=canvas&viewport=109%2C255%2C0.13&t=VUOD3Pw4qiFG5Ope-1&scaling=contain&content-scaling=fixed"
     }
]

//"https://www.figma.com/proto/LwCfAyLZaA0P1umhRj4cvL/Apartly-Design-Systems?page-id=7%3A1650&node-id=7-1651&node-type=canvas&viewport=109%2C255%2C0.13&t=VUOD3Pw4qiFG5Ope-1&scaling=contain&content-scaling=fixed"



export default class Work extends Component {

    componentDidMount(){
        document.title = "Vivien Geschwind | Portfolio"
        window.scrollTo(0,0)
      }
      
    render() {
        return (
            <section id='work' class='content'>
                <div id="work-intro">
                    
                <h1 id='work-hello'>Hi, I'm <span class="">Vivien</span>.</h1>
                {/* <h3 id='work-statement'>I <span class="">design</span> digital <span class="">experiences</span> and help people make their <span class="">visions</span> visible to the world.</h3> */}
                {/* <h3 id='work-statement'>I'm passionate about creating digital experiences and <span class="">making people's lives easier</span> through design <br/><span id="statement-underline">so they can spend more time on the things they enjoy.</span></h3> */}
                <h3 id='work-statement'>I'm an Associate Product Manager @ Quinyx. </h3>
                {/* <h3 id='work-statement'>A <span>happy</span> and open-minded <span class="yellow bold">designer</span> who likes creating digital <span class="purple bold">experiences</span> and helping people make their <span class="turqu bold">visions</span> visible to the world.</h3> */}
                {/* <h3 id='work-statement'>I'm a happy and open-minded designer in Stockholm who likes creating digital experiences and helping people make their visions visible to the world.</h3> */}
                <p id="work-subline" class="uppercase">B a s e d &nbsp; i n &nbsp; S t o c k h o l m &nbsp;</p>
                
                </div>
                <Grid id="grid" container spacing={{xs: 4, md: 6}}>
                   
                    {
                       portfolio.map(({id, company, title, image, url}) => {
                           return (
                    
                    <Grid item xs ={12} md={6} lg={4} key={id}>
                                {/* <Link class="project-link" to={url} target="_blank"> */}
                                <a href = {url} target = "_blank">
                                <article key = {id} className='project-item'>
                        <img class="project-image" src={image} width="300px"></img>
                        {/* <div class="project-item-banner">
                            <div class="project-item-text">
                        <div class="company uppercase purple">{company}</div>
                        <div class="title">{title}</div> */}
                        {/* </div> */}
                        {/* </div> */}
                    </article>
                    </a>
                    {/* </Link> */}
                  </Grid>
                           )
                           })
                        }
                </Grid>
                <div id='work-info'>
                {/* <div id='coming-soon'class="uppercase">M o r e &nbsp; W o r k &nbsp; s a m p l e s &nbsp; w i l l &nbsp; b e &nbsp; p u b l i s h e d &nbsp; s h o r t l y </div> */}
                <h2 id="work-header" class="">About&nbsp;my&nbsp;work</h2>
                <div class="work-about">
                    <div id='introduction'>
                    <p>Good, thoughtful product decisions are at the heart of exceptional user experiences. As a Product Manager, I focus on understanding user needs, identifying meaningful problems to solve, and turning insights into products and experiences that are intuitive, useful, and valuable. </p> 
                    <p> I strive for a human-centered approach, and I value authenticity and sincerity towards the user.</p>
                    {/* <p>Want to work with me or say hi? <a class="contact" href="mailto:vivien-geschwind@live.de">Let’s have a coffee.</a> </p> */}
                    </div>
                    <div class='services services-margin'>
                        <h4 class="uppercase background">W h a t &nbsp; I &nbsp; d o</h4>
                        <ul>
                        <li>Product Discovery</li>
                        <li>Requirements Gathering</li>
                        <li>Sprint Planning</li>
                        <li>Backlog Prioritization</li>
                        <li>Roadmap Management</li>
                        <li>Stakeholder Alignment</li>
                        </ul>
                    </div>
                    <div class='services'>
                        <h4 class="uppercase background">W h a t &nbsp; I &nbsp; w o r k &nbsp; w i t h</h4>
                        <ul>
                            <li>Jira / Figma</li>
                            <li>Claude / Gemini</li>
                            <li>Visual Studio Code / Git</li>
                            <li>HTML / CSS / JS / React</li>
                        </ul>
                    </div>
                </div>
                </div>
            </section>
            
        )
    }
}